import "./styles.css";

import wordbank from "./wordbank.json";

import Game from "./Game";
import { getSolutionIndex } from "./utils";

export default function App() {
  const predeterminedState = document.location.search.replace(/^\?/, "");
  const state = !!predeterminedState
    ? predeterminedState
    : "" + Math.ceil(Math.random() * 10000);
  const solution = wordbank[getSolutionIndex(wordbank.length, state)];
  return (
    <div className="h-full w-screen">
      <Game wordbank={wordbank} solution={solution} seed={state} />
    </div>
  );
}
